import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_membership_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  card_no_old: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  membership_class_guid: fromDatatype.GuidDataFieldInterface;
  membership_class_code: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  obj_status: fromDatatype.VarcharDatatypeInterface;
  status_01: fromDatatype.VarcharDatatypeInterface;
  status_02: fromDatatype.VarcharDatatypeInterface;
  member_id: fromDatatype.VarcharDatatypeInterface;
  card_type: fromDatatype.VarcharDatatypeInterface;
  referral_code: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  sales_agent_guid: fromDatatype.GuidDataFieldInterface; 
  sales_agent_name: fromDatatype.VarcharDatatypeInterface;
  sales_agent_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_crm_membership_hdr_RowClass
  implements bl_crm_membership_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  card_no_old: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  id_type: fromDatatype.VarcharDatatypeInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  membership_class_guid: fromDatatype.GuidDataFieldInterface;
  membership_class_code: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  obj_status: fromDatatype.VarcharDatatypeInterface;
  status_01: fromDatatype.VarcharDatatypeInterface;
  status_02: fromDatatype.VarcharDatatypeInterface;
  member_id: fromDatatype.VarcharDatatypeInterface;
  card_type: fromDatatype.VarcharDatatypeInterface;
  referral_code: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  sales_agent_guid: fromDatatype.GuidDataFieldInterface; 
  sales_agent_name: fromDatatype.VarcharDatatypeInterface;
  sales_agent_code: fromDatatype.VarcharDatatypeInterface;
}
